import React from 'react';
import { Button, Grid } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { usePermissions } from '../../../context/PermissionContext';

interface Props {
  module: string;
  onBlock?: () => void;
  onUnblock?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
  onAdd?: () => void;
  showEdit?: boolean;
  showAdd?: boolean;
  blockLabel?: string;
  unblockLabel?: string;
}

const PermissionActionButtons: React.FC<Props> = ({ 
  module, 
  onBlock, 
  onUnblock, 
  onDelete, 
  onEdit,
  onAdd,
  showEdit = false,
  showAdd = false,
  blockLabel,
  unblockLabel
}) => {
  const { hasPermission } = usePermissions();

  return (
    <Grid container spacing={1}>
      {showAdd && hasPermission(module, 'Add') && onAdd && (
        <Grid>
          <Button
            variant="outlined"
            color="primary"
            onClick={onAdd}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Add
          </Button>
        </Grid>
      )}
      
      {showEdit && hasPermission(module, 'Edit') && onEdit && (
        <Grid>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<EditIcon />}
            onClick={onEdit}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Edit
          </Button>
        </Grid>
      )}

      {hasPermission(module, 'Block') && onBlock && (
        <Grid>
          <Button
            variant="outlined"
            color="warning"
            startIcon={<BlockIcon />}
            onClick={onBlock}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            {blockLabel || 'Block'}
          </Button>
        </Grid>
      )}

      {hasPermission(module, 'Unblock') && onUnblock && (
        <Grid>
          <Button
            variant="outlined"
            color="success"
            startIcon={<CheckIcon />}
            onClick={onUnblock}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            {unblockLabel || 'Unblock'}
          </Button>
        </Grid>
      )}

      {hasPermission(module, 'Delete') && onDelete && (
        <Grid>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onDelete}
            size="small"
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          >
            Delete
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default PermissionActionButtons; 